import * as React from "react";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { ApplyBodyFont } from "source/app/services/UI/Fonts/BodyFont";
import { useIndexedDb } from "source/app/services/Shared/Hooks/useIndexedDb";
import { ShareState } from "source/app/services/UI/State/ShareState";

export function FontPreferenceController() {
    const [useAnopenscrollFont, setUseAnopenscrollFont] = React.useState(false);

    ShareState(
        ESharedFunction.FontSwitcher_useAnopenscrollFont,
        useAnopenscrollFont,
        setUseAnopenscrollFont
    );

    React.useEffect(() => {
        const event = new CustomEvent<boolean>(
            ESharedFunction[ESharedFunction.FontSwitcher_useAnopenscrollFont],
            { detail: useAnopenscrollFont }
        );
        document.dispatchEvent(event);
    }, [useAnopenscrollFont]);

    useIndexedDb(
        ESharedFunction.FontSwitcher_useAnopenscrollFont,
        useAnopenscrollFont
    );

    React.useEffect(() => {
        ApplyBodyFont(useAnopenscrollFont);
    }, [useAnopenscrollFont]);

    return null;
}
